import React, { useContext } from "react";
import "./account_history.css";

import { StateContext } from "../App";

function Account_History(props) {
  // const { state, dispatch } = props;
  const { state, dispatch } = useContext(StateContext);

  const hostName = window.location.hostname
  const uri = `${window.location.hostname}/access/referral/#/signup/${state.user ? state.user._id : null}`

  return (
    <div className="account_history">
      <div className="container">
        <div className="history-tab">
          <h2>account history</h2>
          <div className="divider"></div>

          <div className="grey darken-4 card z-depth-0">
            <div className="grey darken-4 card-content">
            <span className="fields"><i className="fas fa-calendar-plus"> </i> registration date</span>
              <div className="dynamic-details truncate">
                {" "}
                {state.user ? state.user.date : null}
              </div>
            </div>
          </div>

          <div className="grey darken-4 card">
            <div className="grey darken-4 card-content">
            <span className="fields"><i className="far fa-user"></i> account name</span>
              <div className="dynamic-details">
                {" "}
                {state.user ? state.user.name : null}
              </div>
            </div>
          </div>

          <div className="grey darken-4 card">
            <div className="grey darken-4 card-content">
            <span className="fields"><i class="fas fa-envelope"></i> email</span>
              <div className="fields-investment dynamic-details">
                {" "}
                {state.user ? state.user.email : null}
              </div>
            </div>
          </div>

          <div className="grey darken-4 card">
            <div className="grey darken-4 card-content">
              <div className="row center">
                <div className="col s12 m12 l12">
                <span className="fields">
                referral link <i className="fas fa-link"></i>:
              </span>
                </div>
                <div className="col s12 m12 l12">
                <div className="url-input">
                  {uri}
              </div>
                </div>                           
              </div>
            </div>
          </div>

          {/* <div className="grey darken-4 card">
            <div className="grey darken-4 card-content">

            </div>
          </div> */}
          
        </div>
      </div>
    </div>
  );
}

export default Account_History;
